import React from "react";
import {
  List,
  Popconfirm,
  message,
  Skeleton,
  Divider,
  Tag,
  Button,
  Icon,
  Empty,
} from "antd";
import axios from "axios";
import { withTranslation } from "react-i18next";
import TaskForm from "../Tasks/TaskForm";
import moment from "moment";

class LeadFormTaskSidebar extends React.Component {
  state = {
    modalTask: {},
    modalRequestType: "",
    // modalLoading: true,
    modalBtnText: "",
    modalVisible: false,
    modalTitleText: "",
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
  }

  handleDelete(taskID) {
    axios
      .delete(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/delete/`)
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          const data = this.props.lead.tasks;
          const data_fixed = data.filter((item) => item.id !== taskID);
          let new_data = this.props.lead;
          new_data.tasks = data_fixed;
          this.props.handleState("lead", new_data);
          message.success(
            this.props.t("tasks.task_list.task_deleted", "Task deleted")
          );
        } else {
          message.warning(
            this.props.t(
              "tasks.task_list.task_deletion_failed",
              "Deletion failed"
            )
          );
        }
      });
  }

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  confirmDelete(event, taskID) {
    event.preventDefault();
    this.handleDelete(taskID);
  }

  showModal = () => {
    this.formRef.resetFields();
    const [p] = [this.props];
    this.setState({
      modalVisible: true,
      modalTitleText: this.props.t(
        "tasks.task_list.modal_title_create",
        "Create a new task"
      ),
      modalRequestType: "post",
      modalBtnText: this.props.t("general.create", "Create"),
      modalTask: { lead: p.lead },
    });
  };

  hideModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  handleCreate = () => {
    this.formRef.validateFields((err, values) => {
      if (err) {
        return;
      }

      const postObj = {
        ...values,
      };

      this.hideModal();
      axios
        .post(process.env.REACT_APP_AXIOS_URL + "/api/tasks/create/", postObj)
        .then((res) => {
          if (res.status === 201) {
            this.props.fetch();
            message.success(
              this.props.t(
                "tasks.task_list.task_created",
                "Task created successfully"
              )
            );
          }
        });

      this.formRef.resetFields();
    });
  };

  handlePreview = (event) => {
    const taskID = event.currentTarget.getAttribute("data-task_id");
    this.formRef.resetFields();
    axios
      .get(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/`)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            modalTask: res.data,
            // modalLoading: false,
            modalBtnText: undefined,
            modalVisible: true,
            modalRequestType: "get",
            modalTitleText: this.props.t(
              "tasks.task_list.modal_title_preview",
              "Previewing a task"
            ),
          });
        } else {
          console.log("viewing error");
          // this.props.history.push('/tasks');
        }
      });
  };

  handleEditPreview = (event) => {
    const taskID = event.currentTarget.getAttribute("data-task_id");
    this.formRef.resetFields();
    axios
      .get(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/`)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            modalTask: res.data,
            // modalLoading: false,
            modalBtnText: this.props.t("general.update", "Update"),
            modalVisible: true,
            modalRequestType: "put",
            modalTitleText: this.props.t(
              "tasks.task_list.modal_title_update",
              "Update task"
            ),
          });
        } else {
          console.log("edit preview error");
          // this.props.history.push('/tasks');
        }
      });
  };

  handleEdit = (event) => {
    this.formRef.validateFields((err, values) => {
      if (err) {
        return;
      }

      const postObj = {
        ...values,
      };
      const taskID = this.state.modalTask.id;
      this.hideModal();
      axios
        .put(
          process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/update/`,
          postObj
        )
        .then((res) => {
          if (res.status === 200) {
            this.props.fetch();
            message.success(
              this.props.t(
                "tasks.task_list.task_updated",
                "Task have been updated"
              )
            );
          }
        });

      // this.formRef.resetFields();
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  render() {
    const { tasks, t } = this.props;
    if (this.props.loading) {
      return (
        <div>
          <Skeleton active loading={this.props.loading} />
          <Skeleton active loading={this.props.loading} />
          <Skeleton active loading={this.props.loading} />
          <Skeleton active loading={this.props.loading} />
          <Skeleton active loading={this.props.loading} />
        </div>
      );
    } else {
      return (
        <div>
          <Button
            style={{ borderRadius: "0px" }}
            type="dashed"
            onClick={this.showModal}
          >
            <Icon type="plus" />
            {t("general.create", "Create")}
          </Button>
          {tasks && tasks.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={tasks}
              renderItem={(task) => (
                <List.Item>
                  <List.Item.Meta
                    // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                    title={
                      <div>
                        <b>{task.title}</b>
                        <br />
                        {task.due_date && (
                          <span>
                            {t("tasks.task_form.due_date", "Due date")}:{" "}
                            <b style={{ color: "#ec7575" }}>
                              {moment(task.due_date).format("MMM DD YYYY")}
                            </b>
                          </span>
                        )}
                      </div>
                    }
                    description={
                      <div>
                        <a
                          onClick={this.handlePreview}
                          data-task_id={task.id}
                          key="task=list-view"
                        >
                          View
                        </a>{" "}
                        <Divider type="vertical" />
                        <a
                          onClick={this.handleEditPreview}
                          data-task_id={task.id}
                          key="task-list-edit"
                        >
                          Edit
                        </a>{" "}
                        <Divider type="vertical" />
                        <Popconfirm
                          title={t(
                            "tasks.task_list.task_delete",
                            "Are you sure want to delete this task?"
                          )}
                          onConfirm={(event) => {
                            this.confirmDelete(event, task.id);
                          }}
                          okText={t("general.yes", "Yes")}
                          cancelText={t("general.no", "No")}
                          className="data-id={task.id}"
                        >
                          <a key="task-list-delete" href="#">
                            {t("general.delete", "Delete")}
                          </a>
                        </Popconfirm>
                        <br></br>
                        {task.description}
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
          <TaskForm
            wrappedComponentRef={(form) => (this.formRef = form)}
            visible={this.state.modalVisible}
            onCancel={this.hideModal}
            btnText={this.state.modalBtnText}
            titleText={this.state.modalTitleText}
            handleState={this.handleState}
            requestType={this.state.modalRequestType}
            data={this.state.modalTask}
            fetch={this.props.fetch}
            tags={this.props.tags}
            users={this.props.users}
            contacts={this.props.contacts}
            status_list={this.props.task_status}
            priority_list={this.props.task_priority}
            // lead_list={this.props.leads}
          />
        </div>
      );
    }
  }
}

export default withTranslation()(LeadFormTaskSidebar);



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadFormTaskSIdebar.js